import { FutureTabContent } from "@/components/patients/FutureTabContent";
import { VaccinationFormDialog } from "@/components/applications/ApplicationFormDialog";
import { buildUpcomingContextFromRow, type UpcomingApplicationDialogContext } from "@/components/applications/upcoming-dialog-context";
import { AppointmentDetailsDialog } from "@/components/calendar/AppointmentDetailsDialog";
import { useFutureRows } from "@/hooks/useFutureRows";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface PatientFutureTabProps {
  petId: string;
  ownerId: string | null;
  clinicId: string | null;
  includeGrooming?: boolean;
}

export function PatientFutureTab({
  petId,
  ownerId,
  clinicId,
  includeGrooming = true,
}: PatientFutureTabProps) {
  const { t } = useTranslation("patients");
  const [selectedUpcomingItem, setSelectedUpcomingItem] = useState<UpcomingApplicationDialogContext | null>(null);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState<string | null>(null);
  const { pendingRows, upcomingRows, isLoading } = useFutureRows({
    scope: "patient",
    petId,
    ownerId,
    clinicId,
    includeGrooming,
  });

  return (
    <>
      <FutureTabContent
        pendingRows={pendingRows}
        upcomingRows={upcomingRows}
        isLoading={isLoading}
        showClinicHint={!clinicId}
        pendingEmptyMessage={t("futureTab.emptyPendingPatient")}
        upcomingEmptyMessage={t("futureTab.emptyPatient", { defaultValue: "Nenhum item futuro encontrado com os filtros atuais." })}
        onVaccinationSelect={(vaccination) => {
          setSelectedUpcomingItem(buildUpcomingContextFromRow({ petId, vaccination }));
        }}
        onPlanSelect={(plan) => {
          setSelectedUpcomingItem(buildUpcomingContextFromRow({ petId, plan }));
        }}
        onAppointmentSelect={(row) => {
          if (!row.appointmentId) return;
          setSelectedAppointmentId(row.appointmentId);
        }}
      />
      {selectedAppointmentId ? (
        <AppointmentDetailsDialog
          appointmentId={selectedAppointmentId}
          open={Boolean(selectedAppointmentId)}
          onOpenChange={(open) => {
            if (!open) setSelectedAppointmentId(null);
          }}
        />
      ) : null}
      {selectedUpcomingItem && clinicId ? (
        <VaccinationFormDialog
          open={Boolean(selectedUpcomingItem)}
          onOpenChange={(open) => {
            if (!open) {
              setSelectedUpcomingItem(null);
            }
          }}
          petId={petId}
          clinicId={clinicId}
          upcomingContext={selectedUpcomingItem}
          initialTab="record"
          showCreateAppointmentToggle
        />
      ) : null}
    </>
  );
}
